import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TProvider, TProviderResponse, adaptProviderFromResponse } from '../../types';
import { BACKEND_ADMIN_PROVIDER } from '../../backend-paths';


export const providerReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_PROVIDER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_PROVIDER}/${payload}`;

		return HttpService.get<TProviderResponse>(path).then(result => {
			return adaptProviderFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProvider> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerReadSlice = createSlice({
	name: 'providerReadSlice',
	initialState,
	reducers: {
		setProviderRead(state, action: PayloadAction<TProvider>) {
			state.item = action.payload;
		},

		clearProviderRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerReadGetApi.fulfilled.type]: (state, action: PayloadAction<TProvider>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderReadSelector = () => useAppSelector(state => state[providerReadSlice.name]);

export const { clearProviderRead, setProviderRead } = providerReadSlice.actions;
